import React, {useContext, useEffect, useState } from "react";
import NewDrops from "./NewDrops";
import Trending from "./Trending";
import { ProductContext } from "../contexts/ProductContext";
import ProductSlider from "./ProductSlider";
import { Link } from "react-router-dom";

function FilterSection() {
  const { products } = useContext(ProductContext);

  const [activeTab, setActiveTab] = useState("new"); // State to track the active tab

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const [newArrivals, setNewArrivals] = useState([]);
  const [trending, setTrending] = useState([]);
 
  useEffect(() => {
  //  const newArrivalsFilter = products.filter(product => product.newArrival === true)
   const newArrivalsFilter = products.filter(product => product.tags.includes("newArrival"));

  //  const trendingFilter = products.filter(product => product.trending === true)
   const trendingFilter = products.filter(product => product.tags.includes("trending"));

    setNewArrivals(newArrivalsFilter)
    setTrending(trendingFilter)
  }, [products]);

  return (
    <section id="filter-products" className="mt-4">
      <div className="flex justify-center items-center gap-2 capitalize tabs-container">
        {/*  <button
          className={`filter-btn p-2 rounded-sm focus:shadow-lg  ${
            activeTab === "new"
              ? "bg-primarybg text-white"
              : "bg-btnbg text-black"
          }`} */}
        <button
         className={`filter-btn  px-4 p-1 border font-secondaryFont text-md text-primary font-semibold tracking-[1px] transition-border duration-500  ${
          activeTab === "new"
            ? "shadow-lg border-black"
            : ""
        }`}
          onClick={() => handleTabClick("new")}
        >
          New Drops
        </button>
        <button
          className={`filter-btn  px-4 p-1 border font-secondaryFont text-md text-primary font-semibold tracking-[1px] transition-border duration-500  ${
            activeTab === "trending"
              ? "shadow-lg border-black"
              : ""
          }`}
          onClick={() => handleTabClick("trending")}
        >
          Most Trending
        </button>
      </div>
      <div className="container products-container">
        {activeTab === "new" ? (
          // <NewDrops  products={newArrivals}/>
          <ProductSlider products={newArrivals} howManyProductShowCss="w-1/2 md:w-1/4  "/>
        ) : activeTab === "trending" ? (
          <ProductSlider products={trending} howManyProductShowCss="w-1/2 md:w-1/4 "/>

          // <Trending products={trending}/>
        ) : null}
      </div>
      <div className="p-2 view-all-btn w-full text-center">
      <Link to={`/products`}> <button className="hover:shadow-lg px-4 p-1 border hover:border-black font-secondaryFont text-md text-primary tracking-[2px] transition-border duration-300">View All</button></Link>
      </div>
    </section>
  );
}

export default FilterSection;
